module.exports = __webpack_public_path__ + "static/media/bb.68cbe434.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bb.svg
// module id = 59
// module chunks = 0